<template>
    <Header></Header>
    <Left></Left>
    <section class="container">
        <div class="blue_box _full">
            <div class="box_tit _flex">
                <h2>뉴스레터 수신동의</h2>
                <div class="info_box">
                    <div>
                        구독자
                        <span class="col_blue">{{ CommonUtils.numberFormat(state.totalLength) }}명</span>
                    </div>
                </div>
            </div>

            <div class="sch_condition_wrap">
                <div class="left">
                    <div class="select_date_wrap">
                        <div class="select_date">
                            <input
                                type="date"
                                v-model="state.startDate"
                                @change="
                                    state.page = 1;
                                    getList();
                                "
                            />
                        </div>
                        <div class="select_date">
                            <input
                                type="date"
                                v-model="state.endDate"
                                @change="
                                    state.page = 1;
                                    getList();
                                "
                                style="margin-left: 5px"
                            />
                        </div>
                    </div>
                    <div class="radio_wrap sch_list">
                        <label for="chkAll">
                            <input
                                id="chkAll"
                                name="cate"
                                type="radio"
                                :value="null"
                                v-model="state.searchState"
                                @change="
                                    state.page = 1;
                                    getList();
                                "
                            />
                            <em></em>
                            <span>전체</span>
                        </label>
                        <label for="chk1">
                            <input
                                id="chk1"
                                name="cate"
                                type="radio"
                                :value="1"
                                v-model="state.searchState"
                                @change="
                                    state.page = 1;
                                    getList();
                                "
                            />
                            <em></em>
                            <span>처리완료</span>
                        </label>
                        <label for="chk2">
                            <input
                                id="chk2"
                                name="cate"
                                type="radio"
                                :value="0"
                                v-model="state.searchState"
                                @change="
                                    state.page = 1;
                                    getList();
                                "
                            />
                            <em></em>
                            <span>미처리</span>
                        </label>
                    </div>
                    <div class="select_tab_box _130">
                        <div
                            class="selected_tab"
                            :class="[state.isShowSearchType ? 'active' : '']"
                            @click="state.isShowSearchType = !state.isShowSearchType"
                        >
                            <span>{{ state.detailTxt }}</span>
                        </div>
                        <div class="tab_option">
                            <button
                                v-for="item in search_type_list"
                                @click="
                                    state.searchType = item.key;
                                    state.detailTxt = item.value;
                                    state.isShowSearchType = false;
                                "
                            >
                                {{ item.value }}
                            </button>
                        </div>
                    </div>
                    <div class="search_wrap">
                        <input
                            type="text"
                            v-model="state.searchText"
                            @keyup.enter="
                                state.page = 1;
                                getList();
                            "
                            placeholder="검색어를 입력하세요."
                        />
                        <button
                            type="button"
                            class="search_btn icon_wrap"
                            @click="
                                state.page = 1;
                                getList();
                            "
                        >
                            <img src="img/search_btn.png" alt="" />
                        </button>
                    </div>
                </div>
                <div class="right">
                    <button type="button" class="default_btn _gray" @click="isDelete">삭제</button>
                    <button type="button"><img src="img/excel_icon.png" @click="downloadFile" alt=" 엑셀 다운로드" /></button>
                </div>
            </div>

            <div class="common_table custom_scroll">
                <table>
                    <colgroup>
                        <col style="width: 40px" />
                        <col style="width: 100px" />
                        <col />
                        <col />
                        <col style="width: 60px" />
                        <col style="width: 160px" />
                        <col style="width: 120px" />
                    </colgroup>
                    <thead>
                        <tr>
                            <th class="checkbox_wrap cnt p_5 checkbox_wrap2">
                                <input type="checkbox" v-model="state.checkAll" @change="toggleAll()" />
                            </th>
                            <th>번호</th>
                            <th>이름</th>
                            <th>이메일</th>
                            <th>상태</th>
                            <th>처리일</th>
                            <th>수집일</th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-if="state.list.length > 0">
                            <tr v-for="(item, idx) in state.list" :key="item.idx">
                                <td class="checkbox_wrap cnt p_5 checkbox_wrap2">
                                    <label :for="'chk_' + item.idx" @click.stop>
                                        <input type="checkbox" :id="'chk_' + item.idx" v-model="state.checkedList" :value="item.idx" @click.stop />
                                        <em></em>
                                    </label>
                                </td>

                                <td class="list_num">{{ (state.page - 1) * state.size + (idx + 1) }}</td>
                                <td>{{ item.name }}</td>
                                <td>{{ item.email }}</td>

                                <td class="cnt checkbox_wrap _plus">
                                    <label :for="'chk_state' + item.idx">
                                        <input
                                            :id="'chk_state' + item.idx"
                                            type="checkbox"
                                            :value="item.idx"
                                            :checked="item.state === 1"
                                            @click="isDone(item.idx)"
                                        />
                                        <em></em>
                                    </label>
                                </td>
                                <td class="cnt">{{ item.doneDate ? CommonUtils.dateFormat(new Date(item.doneDate), ".", true) : "" }}</td>
                                <td class="cnt">{{ CommonUtils.dateFormatYY(new Date(item.createDate), ".") }}</td>
                            </tr>
                        </template>
                        <tr v-else>
                            <td colspan="5">
                                <div class="tb_subject" style="text-align: center; width: 100%">등록된 게시물이 없습니다.</div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <PageBtn
                v-if="state.list.length !== 0"
                :currentPage="state.page"
                :totalLength="state.totalLength"
                :perPage="state.size"
                @onPaging="handlePageChange"
            ></PageBtn>
        </div>
    </section>

    <ModalDefault
        v-if="state.isShowModal"
        :type="state.modalTab"
        :title="state.modalTitle"
        :content="state.modalContent"
        @close="closeModal"
        @callback="callBackModal"
    ></ModalDefault>
</template>
<script lang="ts" config>
    import {
        userStore,
        globalStore,
        popupStore,
        reactive,
        watch,
        apiService,
        onMounted,
        router,
        Header,
        Left,
        ModalDefault,
        types,
        ref,
        onBeforeUnmount,
        getMessageByCode,
        PageBtn,
        CommonUtils,
    } from "@/BaseComponent";

    export default {
        props: {},
        components: { Header, Left, ModalDefault, PageBtn },
        setup() {
            const global = globalStore();
            const user = userStore();
            const popup = popupStore();

            const state = reactive({
                list: [] as Array<any>,
                checkedList: [] as Array<number>,
                checkAll: false as boolean,

                searchType: "" as string,
                searchText: "" as string,
                startDate: "" as string,
                endDate: "" as string,

                searchState: null as null | 0 | 1,

                page: 1 as number,
                size: 20 as number,
                totalPage: 1 as number,
                totalLength: 0 as number,

                detailTxt: "전체" as string,
                isShowSearchType: false,

                isShowModal: false as boolean,
                modalTab: -1 as number,
                modalIsResult: false as boolean,
                modalTitle: "alert" as string,
                modalContent: "" as string,
            });

            const imgError = (e: Event) => {
                const target = e.target as HTMLImageElement;
                if (target) {
                    target.src = require("@/assets/no_img.png");
                }
            };

            onMounted(() => {
                getList();
                // global.$reset();
            });

            onBeforeUnmount(() => {});

            watch(
                () => [state.checkedList, state.list],
                () => {
                    state.checkAll = state.checkedList.length > 0 && state.checkedList.length === state.list.length;
                },
            );

            const closeModal = () => {
                state.isShowModal = false;
            };

            const callBackModal = async (param: any) => {
                if (param.action === "confirm") {
                    deleteCheckList();
                }
            };

            const handlePageChange = (page: number) => {
                state.page = page;
                getList();
            };

            const search_type_list = [
                { id: "all", key: "all", value: "전체" },
                { id: "1", key: "name", value: "이름" },
                { id: "2", key: "email", value: "이메일" },
            ];

            const openIndex = ref(null);
            const toggle = (idx: any) => {
                openIndex.value = openIndex.value === idx ? null : idx;
            };

            const toggleAll = () => {
                if (state.checkAll) {
                    state.checkedList = state.list.map((item) => item.idx);
                } else {
                    state.checkedList = [];
                }
            };

            const getList = async () => {
                state.checkedList = [];
                const param: types.ReqSubscribeList = {
                    page: state.page,
                    size: state.size,
                    searchType: state.searchType,
                    searchText: state.searchText,
                    state: state.searchState,

                    startDate: state.startDate,
                    endDate: state.endDate,
                };

                const res = await apiService.subscribe.list(param);
                if (res.returnCode === 0) {
                    state.list = res.list.data;
                    state.totalPage = res.list.totalPages;
                    state.totalLength = res.list.recordsTotal;
                } else {
                    state.list = [];
                    state.totalPage = 0;
                    state.totalLength = 0;
                }
            };

            const isDelete = () => {
                if (state.checkedList && state.checkedList.length > 0) {
                    state.modalTab = 5;
                    state.modalTitle = "알림";
                    state.modalContent = "정말 삭제하시겠습니까?";
                    state.isShowModal = true;
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "선택된 게시글이 없습니다.";
                    state.isShowModal = true;
                }
            };

            const deleteCheckList = async () => {
                if (state.checkedList && state.checkedList.length > 0) {
                    const res = await apiService.subscribe.multiRemove(state.checkedList.join(","));
                    if (res.returnCode === 0) {
                        state.modalTab = -1;
                        state.modalTitle = "알림";
                        state.modalContent = "삭제가 완료되었습니다.";
                        state.isShowModal = true;

                        getList();
                        state.checkedList = [];
                    } else if (res.returnCode === 11) {
                    } else {
                        state.modalTab = -1;
                        state.modalTitle = "예외 발생";
                        state.modalContent = getMessageByCode(res.returnCode);
                        state.isShowModal = true;
                    }
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "선택된 게시글이 없습니다.";
                    state.isShowModal = true;
                }
            };

            const downloadFile = async () => {
                try {
                    const param: types.ReqSubscribeForExcel = {
                        searchType: state.searchType,
                        searchText: state.searchText,
                        startDate: state.startDate,
                        endDate: state.endDate,
                        idxList: String(state.checkedList),
                        state: state.searchState,
                    };

                    let res = await apiService.subscribe.exportExcel(param);

                    if (res && res.data) {
                        const blob = new Blob([res.data], {
                            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                        });
                        const disposition = res.headers["content-disposition"];
                        let fileName = "download.xlsx";
                        if (disposition) {
                            const match = disposition.match(/filename="?(.+)"?/);
                            if (match && match[1]) {
                                fileName = decodeURIComponent(match[1]);
                            }
                        }
                        const a = document.createElement("a");
                        const url = window.URL.createObjectURL(blob);
                        a.href = url;
                        a.download = fileName;
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                        URL.revokeObjectURL(url);
                    } else {
                        state.modalTab = -1;
                        state.modalTitle = "알림";
                        state.modalContent = getMessageByCode(res.returnCode);
                        state.isShowModal = true;
                    }
                } catch (err) {
                    console.error("파일 다운로드 실패:", err);
                }
            };

            const isDone = async (idx: number) => {
                const res = await apiService.subscribe.isDone(idx);
                if (res.returnCode === 0) {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "완료되었습니다.";
                    state.isShowModal = true;

                    getList();
                } else if (res.returnCode === 11) {
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "예외 발생";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            return {
                state,
                user,
                router,
                closeModal,
                callBackModal,
                imgError,
                types,
                global,
                popup,
                handlePageChange,
                CommonUtils,
                search_type_list,
                getList,
                deleteCheckList,
                toggle,
                isDelete,
                toggleAll,
                openIndex,
                downloadFile,
                isDone,
            };
        },
    };
</script>
<style>
    .checkbox_wrap2 input[type="checkbox"] {
        appearance: auto;
        -webkit-appearance: auto;
        -moz-appearance: auto;
        display: inline-block;
        width: 22px;
        height: 22px;
        background-color: #fff;
        position: relative;
        vertical-align: sub;
        cursor: pointer;
        border: 1px solid #6d6d6d;
    }

    .checkbox_wrap2 em {
        display: none;
    }
</style>
